<template>
  <div class="c-matrix">
    <matrix-row>
        <span v-for="(title, key) in columnTitles" :key="key">{{ title }}</span>
    </matrix-row>
    <slot />
  </div>
</template>

<script>
import MatrixRow from "./MatrixRow";
export default {
  components: {
    MatrixRow,
  },
  props: {
    columnTitles: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
